import gql from 'graphql-tag';

export const EDIT_STAY_INFORMATION_MUTATION = gql`
  fragment CommonStayInformationFieldsEdit on StayInformation {
    id
    title
    content
    locale
    bannerImage {
      id
      url
      formats
    }
    hidden
    size
    appSortOrder
  }
  mutation EditStayInformation($id: ID!, $data: editStayInformationInput!) {
    updateStayInformation(input: { where: { id: $id }, data: $data }) {
      stayInformation {
        ...CommonStayInformationFieldsEdit
      }
    }
  }
`;
